import { Box } from '@mantine/core';
import AiMatchActions from './ai-actions/AiMatchActions';
import AiRequestMatchesActions from './ai-actions/AiRequestMatchesActions';
import AiNewRequestActions from './ai-actions/AiNewRequestActions';
import AiValidatedRequestActions from './ai-actions/AiValidatedRequestActions';
import AiSearchActions from './ai-actions/AiSearchActions';
import AiGeneratedActions from './ai-actions/AiGeneratedActions';

interface AiEvidenceActionsProps {
  isIdeaPage: boolean;
  isIdeaAi: boolean;
  finalIsGenerated: boolean;
  isGapMatch: boolean;
  isRequestMatch: boolean;
  isRequestInreview: boolean;
  isAssigned: boolean;
  status: string;
  navToPerspective: any;
  componentId: string;
  finalChosenEvidence: any;
  componentType: string;
  propGetUnreadNotificationsCountByRequest?: (requestId: string) => number;
  setActiveSearch?: (active: boolean) => void;
  hoverCard?: boolean;
  setShowHoverCard?: (show: boolean) => void;
}

const AiEvidenceActions: React.FC<AiEvidenceActionsProps> = ({
  isIdeaPage,
  isIdeaAi,
  finalIsGenerated,
  isGapMatch,
  isRequestMatch,
  isRequestInreview,
  isAssigned,
  status,
  navToPerspective,
  componentId,
  finalChosenEvidence,
  componentType,
  propGetUnreadNotificationsCountByRequest,
  setActiveSearch,
  hoverCard,
  setShowHoverCard
}) => {
  // If finalIsGenerated is true, show only "Assign to a new idea" action
  if (finalIsGenerated && (isIdeaPage || isIdeaAi)) {
    return (
      <AiGeneratedActions
        componentId={componentId}
        chosenEvidence={finalChosenEvidence}
        hoverCard={hoverCard}
        setShowHoverCard={setShowHoverCard}
      />
    );
  }

  if (!(isIdeaPage || isIdeaAi)) {
    return null;
  }

  return (
    <Box>
      {isGapMatch && status !== "search" && (
        <AiMatchActions
          hoverCard={hoverCard}
          setShowHoverCard={setShowHoverCard}
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
          setValidationCount={(count: number) => count}
          setIsValidationDone={(done: boolean) => done}
          componentType={componentType}
          getUnreadNotificationsCountByRequest={isIdeaAi ? propGetUnreadNotificationsCountByRequest : undefined}
        />
      )}
      
      {isRequestMatch && status !== "search" && (
        <AiRequestMatchesActions
          setShowHoverCard={setShowHoverCard}
          hoverCard={hoverCard}
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
        />
      )}

      {isRequestInreview && status !== "search" && (
        <AiNewRequestActions
          setShowHoverCard={setShowHoverCard}
          hoverCard={hoverCard}
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
        />
      )}
      
      {(isAssigned && status !== "search") && (
        <AiValidatedRequestActions
          setShowHoverCard={setShowHoverCard}
          hoverCard={hoverCard}
          navToPerspective={navToPerspective}
          chosenEvidence={finalChosenEvidence}
        />
      )}

      {status === "search" && ( 
        <AiSearchActions
          setShowHoverCard={setShowHoverCard}
          hoverCard={hoverCard}
          navToPerspective={navToPerspective}
          setActiveSearch={setActiveSearch}
          chosenEvidence={finalChosenEvidence}
          componentId={componentId}
        />
      )}
    </Box>
  );
};

export default AiEvidenceActions; 